export enum CartPref {
	GLACIER_ARCHIVE_ENABLED = 'glacier.archiveEnabled',
	TMS_WEBSERVICE_ENDPOINT = 'tms.webserviceEndpoint',
	TMS_ACTION_MESSAGE = 'tms.actionMessage',
}
